/* Continuous (infinite) category scroller.
   The track renders the tile set twice. When the viewport scrolls past one
   full set we shift scrollLeft back by exactly that set's width - the content
   is identical at that point, so the seam is invisible and the row never ends.
   This is the same technique Swiper's loop mode uses; Horizon's own `infinite`
   is built for one-slide-at-a-time slideshows and can't scroll past its
   maximum in a multi-column carousel. */
(function () {
  function init(root) {
    var vp = root.querySelector('[data-cat-viewport]');
    var track = root.querySelector('[data-cat-track]');
    if (!vp || !track) return;

    var setWidth = 0;
    var adjusting = false;

    function measure() {
      setWidth = track.scrollWidth / 2;
    }

    function wrap() {
      if (adjusting || !setWidth) return;
      var x = vp.scrollLeft;
      if (x >= setWidth) {
        adjusting = true;
        vp.scrollLeft = x - setWidth;
        adjusting = false;
      } else if (x <= 0) {
        adjusting = true;
        vp.scrollLeft = x + setWidth;
        adjusting = false;
      }
    }

    function tileStep() {
      var tile = track.querySelector('.cat-tile');
      if (!tile) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || '8') || 8;
      return tile.getBoundingClientRect().width + gap;
    }

    measure();
    new ResizeObserver(measure).observe(track);
    vp.addEventListener('scroll', wrap, { passive: true });

    // start just inside the first set so it can scroll either way immediately
    requestAnimationFrame(function () { vp.scrollLeft = 1; });

    var prev = root.querySelector('[data-cat-prev]');
    var next = root.querySelector('[data-cat-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) {
      vp.scrollBy({ left: dir * tileStep(), behavior: reduce ? 'instant' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function boot() {
    document.querySelectorAll('[data-cat-scroll]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
